import jwt_decode from 'jwt-decode';

export const decodeAppToken = token => {
    if (typeof token !== 'string' || !token.trim()) {
        throw new Error('Missing application token');
    }
    return jwt_decode(token.replace(/^Bearer\s+/i, '').trim());
};
